import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-rose-500 text-white hover:bg-rose-600 hover:shadow-lg hover:shadow-rose-200 focus:ring-rose-500',
    secondary: 'bg-stone-800 text-white hover:bg-stone-900 hover:shadow-lg focus:ring-stone-800',
    outline: 'border-2 border-rose-400 text-rose-600 hover:bg-rose-50 focus:ring-rose-500'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-229">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-230" />}
    </button>;
}